import { FieldInputNumber, FieldSelect, Form, FormikForm, FormRowField } from "../forms";

type FormValues = {
  animation: "fade" | "slide" | "zoom" | "cover";
  duration?: number;
};

type Props = {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
};

export const MotionForm = ({ initialValues, onSubmit }: Props) => (
  <FormikForm<FormValues>
    initialValues={initialValues}
    onSubmit={onSubmit}
    submitOnBlur
    formatStrings={formatStrings}
    dataTest="nav-group-form"
  >
    <Form>
      <FormRowField<FormValues> name="animation">
        <FieldSelect
          options={[
            { label: "Fade", value: "fade" },
            { label: "Slide", value: "slide" },
            { label: "Zoom", value: "zoom" },
            { label: "Cover", value: "cover" },
          ]}
        />
      </FormRowField>
      <FormRowField<FormValues> name="duration">
        <FieldInputNumber fractionDigits={2} />
      </FormRowField>
    </Form>
  </FormikForm>
);

const formatStrings = {
  animationLabel: {
    en: "Animation Type",
  },
  durationLabel: {
    en: "Duration (seconds)",
  },
};
